import AccountingDashboardStore from "./Dashboard/AccountingDashboard.Store";
import BillsStore from "./Purchases/Bills/Bills.Store";
// import CustomersStore from "./Sales/Customers/Customers.Store";
import InvoicesStore from "./Sales/Invoices/Invoices.Store";
import PaymentsStore from "./Payments/Payments.Store";
// import SuppliersStore from "./Purchases/Suppliers/Suppliers.Store";
import { POConversionViewStore } from "./po-conversion/stores/POConversionViewStore";
import { InvoiceConversionViewStore } from "./invoice-conversion/stores/InvoiceConversionViewStore";

// PO Queue Stores
import ReceivingQueueStore from "./ReceivingQueue/ReceivingQueue.Store";
import ApprovalQueueStore from "./ApprovalQueue/ApprovalQueue.Store";
import PaymentQueueStore from "./PaymentQueue/PaymentQueue.Store";

// Purchase Order Management (spec 02-purchase-order-management.md)
import PurchaseOrdersStore from "./PurchaseOrders/PurchaseOrders.Store";

// Task/Approval Workflow (spec 03-task-approval-workflow.md)
import TaskWorkflowStore from "./TaskWorkflow/TaskWorkflow.Store";

// Invoice Management (spec 06-invoice-management.md)
import InvoiceManagementStore from "./Invoices/Invoices.Store";

// Accounts Payable (spec 07-accounts-payable.md)
import AccountsPayableStore from "./AccountsPayable/AccountsPayable.Store";

// Accounts Receivable (spec 08-accounts-receivable.md)
import AccountsReceivableStore from "./AccountsReceivable/AccountsReceivable.Store";

// Freight Matching (Implementation Plan Phase 1)
import FreightMatchingStore from "./FreightMatching/FreightMatching.Store";

// Asset Transactions (Implementation Plan Phase 1 - GL Controls)
import AssetTransactionsStore from "./AssetTransactions/AssetTransactions.Store";

// Check Printing (Implementation Plan Phase 1)
import CheckPrintingStore from "./CheckPrinting/CheckPrinting.Store";

// Check Template Designer (Implementation Plan Phase 1)
import CheckTemplateDesignerStore from "./CheckTemplateDesigner/CheckTemplateDesigner.Store";

// Recurring Transactions (Phase 3)
import RecurringTransactionsStore from "./RecurringTransactions/RecurringTransactions.Store";

// Fiscal Periods (Phase 5)
import FiscalPeriodsStore from "./FiscalPeriods/FiscalPeriods.Store";

// General Ledger (GL Implementation Plan)
import GeneralLedgerStore from "./GeneralLedger/GeneralLedger.Store";

// Account Reconciliation (GL Implementation Plan)
import ReconciliationStore from "./Reconciliation/Reconciliation.Store";

// Chart of Accounts (GL Implementation Plan)
import ChartOfAccountsStore from "./ChartOfAccounts/ChartOfAccounts.Store";

// Command Palette (GL Implementation Plan)
import CommandPaletteStore from "components/CommandPalette/CommandPalette.Store";

const accountingStoreList = [
  { name: "accountingDashboardStore", store: AccountingDashboardStore },
  { name: "billsViewStore", store: BillsStore },
  // { name: "customersViewStore", store: CustomersStore },
  { name: "invoicesViewStore", store: InvoicesStore },
  { name: "paymentsViewStore", store: PaymentsStore },
  //   { name: "suppliersViewStore", store: SuppliersStore },
  { name: "poConversionViewStore", store: POConversionViewStore },
  { name: "invoiceConversionViewStore", store: InvoiceConversionViewStore },

  // PO Queue Stores
  { name: "receivingQueueStore", store: ReceivingQueueStore },
  { name: "approvalQueueStore", store: ApprovalQueueStore },
  { name: "paymentQueueStore", store: PaymentQueueStore },

  // Purchase Order Management
  { name: "purchaseOrdersStore", store: PurchaseOrdersStore },

  // Task/Approval Workflow (spec 03)
  { name: "taskWorkflowStore", store: TaskWorkflowStore },

  // Invoice Management (spec 06)
  { name: "invoiceManagementStore", store: InvoiceManagementStore },

  // Accounts Payable (spec 07)
  { name: "accountsPayableStore", store: AccountsPayableStore },

  // Accounts Receivable (spec 08)
  { name: "accountsReceivableStore", store: AccountsReceivableStore },

  // Freight Matching (Implementation Plan Phase 1)
  { name: "freightMatchingStore", store: FreightMatchingStore },

  // Asset Transactions (Implementation Plan Phase 1 - GL Controls)
  { name: "assetTransactionsStore", store: AssetTransactionsStore },

  // Check Printing (Implementation Plan Phase 1)
  { name: "checkPrintingStore", store: CheckPrintingStore },

  // Check Template Designer (Implementation Plan Phase 1)
  { name: "checkTemplateDesignerStore", store: CheckTemplateDesignerStore },

  // Recurring Transactions (Phase 3)
  { name: "recurringTransactionsStore", store: RecurringTransactionsStore },

  // Fiscal Periods (Phase 5)
  { name: "fiscalPeriodsStore", store: FiscalPeriodsStore },

  // General Ledger (GL Implementation Plan)
  { name: "generalLedgerStore", store: GeneralLedgerStore },

  // Account Reconciliation (GL Implementation Plan)
  { name: "reconciliationStore", store: ReconciliationStore },

  // Chart of Accounts (GL Implementation Plan)
  { name: "chartOfAccountsViewStore", store: ChartOfAccountsStore },

  // Command Palette (GL Implementation Plan)
  { name: "commandPaletteStore", store: CommandPaletteStore },
];

export default accountingStoreList;
